import keyBy from 'lodash/keyBy';
import Vue from 'vue';

import * as skillApi from '@authoringPlatform/../api/skills';
import { saveWrap } from './helpers';

const getDefaultState = () => ({
  skills: {},
});

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    createSkill: saveWrap(
      async ({ commit, rootState }, { description, developmentalTactic, name }) => {
        const newSkill = await skillApi.addSkill({
          FK_versionKey: rootState.editMode.version.versionKey,
          description,
          developmentalTactic,
          name,
        });
        commit('SET_SKILL', { skill: newSkill });
        return newSkill.skillKey;
      }
    ),

    updateSkill: saveWrap(
      async ({ commit }, { skillKey, description, developmentalTactic, name }) => {
        const updatedSkill = {
          skillKey,
          description,
          developmentalTactic,
          name,
        };
        await skillApi.updateSkill({ skillKey, payload: updatedSkill });
        commit('UPDATE_SKILL', { skill: updatedSkill });
      }
    ),

    deleteSkill: saveWrap(async ({ commit }, { skillKey }) => {
      await skillApi.deleteSkill(skillKey);
      commit('DELETE_SKILL', { skillKey });
    }),
  },

  mutations: {
    INITIALIZE_SKILLS: (state, { skills }) => {
      // Parse answerToSkill relationships into hash sets for faster lookup
      const parsedSkills = skills.map((skill) => ({
        ...skill,
        answerToSkill: new Set(skill.answerToSkill.map((ats) => ats.FK_answerKey)),
      }));
      state.skills = keyBy(parsedSkills, 'skillKey');
    },

    SET_SKILL: (state, { skill }) => {
      Vue.set(state.skills, skill.skillKey, {
        ...skill,
        answerToSkill: new Set(),
      });
    },

    UPDATE_SKILL: (state, { skill: { skillKey, ...skillAttrs } }) => {
      Object.entries(skillAttrs).forEach(([skillAttr, val]) => {
        Vue.set(state.skills[skillKey], skillAttr, val);
      });
    },

    DELETE_SKILL: (state, { skillKey }) => {
      Vue.delete(state.skills, skillKey);
    },

    ADD_ANSWER_TO_SKILL: (state, { skillKey, answerKey }) => {
      const targetSkill = state.skills[skillKey];
      const newAnswerToSkill = new Set(targetSkill.answerToSkill);
      newAnswerToSkill.add(answerKey);

      Vue.set(targetSkill, 'answerToSkill', newAnswerToSkill);
    },

    DELETE_ANSWER_FROM_SKILL: (state, { skillKey, answerKey }) => {
      const targetSkill = state.skills[skillKey];
      const newAnswerToSkill = new Set(targetSkill.answerToSkill);
      newAnswerToSkill.delete(answerKey);

      Vue.set(targetSkill, 'answerToSkill', newAnswerToSkill);
    },
  },

  getters: {
    skillList: (state) => {
      return Object.values(state.skills);
    },
  },
};
